const API_URL = process.env.REACT_APP_API_URL;

export function newAttemptId() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
  return `a-${Date.now()}-${Math.floor(Math.random() * 1e9)}`;
}

// Fire-and-forget: telemetria nu trebuie să blocheze niciodată UX-ul quiz-ului.
function post(event_type, attempt_id, meta) {
  try {
    fetch(`${API_URL}/events`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event_type, attempt_id, meta }),
    }).catch(() => {});
  } catch (_) { /* noop */ }
}

export const trackQuizStart = (attemptId, meta) => post('quiz_start', attemptId, meta);
export const trackQuizFinish = (attemptId, meta) => post('quiz_finish', attemptId, meta);
